import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL || ""}/api`,
  withCredentials: true,
  timeout: 8000,
  headers: { "Content-Type": "application/json" },
});

// Global email-verification gate: any 403 EMAIL_UNVERIFIED (swipe, list,
// save, chat) raises a window event that opens the verify-email popup —
// pages do not need to handle this case one by one. The error still
// propagates so callers can also undo optimistic UI.
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const data = error?.response?.data;
    const code = data?.code || data?.detail?.code;
    if (error?.response?.status === 403 && code === "EMAIL_UNVERIFIED") {
      try {
        window.dispatchEvent(new CustomEvent("swiprent:email-unverified"));
      } catch {
        /* SSR/test environments without window */
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(error) {
  const detail = error?.response?.data?.detail;
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.message === "string") return detail.message;
  return String(detail);
}

export default api;
